import { render } from "./HistoricalVerificationChecksView.vue?vue&type=template&id=3071a8f2"
import script from "./historical_verification_checks_view.js?vue&type=script&lang=js&external"
export * from "./historical_verification_checks_view.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__